import { useState } from "react";

const useDynamicFields = (initialState) => {
  const [fields, setFields] = useState(initialState ? [initialState] : []);

  const addField = (value = "") => {
    setFields([...fields, value]);
  };

  const removeField = (index) => {
    setFields(fields.filter((_, i) => i !== index));
  };

  const updateField = (index, fieldName, value) => {
    setFields(state =>
      state.map((field, i) => (i === index ? { ...field, [fieldName]: value } : field))
    );
  };

  const resetFields = (resetData) => {

    setFields(resetData ? resetData : initialState ? [initialState] : []);
  };

  return {
    fields,
    addField,
    removeField,
    updateField,
    resetFields,
    setFields
  };
};

export default useDynamicFields;
